module.exports = __webpack_public_path__ + "static/media/biteship-tiktok.d74456af.png";